import { render } from "./ContentsRegComponent.vue?vue&type=template&id=cd67cb06&scoped=true&ts=true"
import script from "./ContentsRegComponent.vue?vue&type=script&lang=ts"
export * from "./ContentsRegComponent.vue?vue&type=script&lang=ts"

import "./ContentsRegComponent.vue?vue&type=style&index=0&id=cd67cb06&scoped=true&lang=css"
import "./ContentsRegComponent.vue?vue&type=style&index=1&id=cd67cb06&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd67cb06"]])

export default __exports__